<div class="container-fluid p-0">
  <div class="row mb-3">
    <div class="col-12">Commands</div>
  </div>
  <div class="row">
    <ng-content></ng-content>
  </div>
</div>
